import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Leader from '../partials/Leader';

import styles from '../../../styles/steps/leaderboard.module.scss';

const propTypes = {
    step: PropTypes.shape({}),
    leaderboard: PropTypes.shape({}),
    isDisplay: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    step: null,
    leaderboard: null,
    isDisplay: false,
    className: null,
};

function Leaderboard({ leaderboard, isDisplay, className }) {
    const themeClassName = useThemeClassName(styles);
    const { leaders = [] } = leaderboard || {};
    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                { [styles.isDisplay]: isDisplay, [className]: className !== null },
            ])}
        >
            <div className={styles.inner}>
                <h1 className={styles.title}>
                    <FormattedMessage defaultMessage="Leaderboard" description="Title label" />
                </h1>
                {leaders.map((leader, index) => (
                    <Leader
                        key={`leader-${leader.id}`}
                        className={styles.leader}
                        position={String(index + 1).padStart(2, '0')}
                        leader={leader}
                    />
                ))}
                {leaders === null || leaders.length === 0 ? (
                    <p className={styles.empty}>
                        <FormattedMessage
                            defaultMessage="No good answer yet!"
                            description="Display message"
                        />
                    </p>
                ) : null}
            </div>
        </div>
    );
}

Leaderboard.propTypes = propTypes;
Leaderboard.defaultProps = defaultProps;

export default Leaderboard;
